import { render, staticRenderFns } from "./inthtEditRight.vue?vue&type=template&id=2da8eaa8&scoped=true&"
import script from "./inthtEditRight.vue?vue&type=script&lang=js&"
export * from "./inthtEditRight.vue?vue&type=script&lang=js&"
import style0 from "./inthtEditRight.vue?vue&type=style&index=0&id=2da8eaa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8eaa8",
  null
  
)

export default component.exports